module.exports = __webpack_public_path__ + "img/Emme-Young.21d84186.jpg";